/* eslint-disable react/no-danger */
import React from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty, map } from 'lodash';
import { Link } from 'gatsby';
import BoxedContainer from './layouts/BoxedContainer';
import Sprites from '../components/Sprites';

export default function FreeZonePrePostApplicationProcess({ data, id }) {
  const {
    title,
    text,
    backgroundImage,
    backgroundImageMobile,
    preApplicationTitle,
    preApplicationList,
    postApplicationTitle,
    postApplicationList,
  } = data;
  return (
    <section id={id} className="relative overflow-hidden bg-[#333]">
      {isEmpty(backgroundImage) || (
        <div
          className="w-full h-[802px] absolute top-0 lazy-load-image:flex
        lazy-load-image:h-ful hidden md:block">
          <LazyLoadImage
            src={backgroundImage.url}
            width="100%"
            effect="blur"
            placeholderSrc={`${backgroundImage}`}
            wrapperClassName='opacity-10 relative before:content-[""] before:block before:absolute 
            before:w-full before:h-[50%] before:left-0 before:bottom-0 image-gradient'
            className="w-full h-full object-cover"
          />
        </div>
      )}
      {isEmpty(backgroundImageMobile) || (
        <div
          className="w-full h-[802px] absolute top-0 lazy-load-image:flex
        lazy-load-image:h-ful md:hidden">
          <LazyLoadImage
            src={backgroundImageMobile.url}
            width="100%"
            effect="blur"
            placeholderSrc={`${backgroundImageMobile}`}
            wrapperClassName='opacity-15 relative before:content-[""] before:block before:absolute 
            before:w-full before:h-[20%] before:left-0 before:bottom-0 image-gradient'
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <BoxedContainer className="py-[50px] md:py-[100px]">
        <div className="flex flex-col gap-y-[30px] md:gap-y-20">
          <div className="flex flex-col gap-y-5 md:gap-y-[30px]">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.4 }}
              viewport={{ once: true }}
              className="flex flex-col gap-y-5">
              <div
                dangerouslySetInnerHTML={{ __html: title }}
                className="text-clamp20to40  h2-child:text-clamp20to40 text-white
              h2-child:leading-1.2 text-center h2-child:m-0"
              />
              <div className="h-[2px] w-[70px] bg-[#CE445B] mx-auto" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.5 }}
              viewport={{ once: true }}
              dangerouslySetInnerHTML={{ __html: text }}
              className="p-child:text-[#CCC] p-child:text-clamp12to18 p-child:font-normal
              p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular 
              p-child:rtl:font-GESSTwoDWTCLight
              text-center"
            />
          </div>
          <div className="flex flex-col gap-y-[25px] md:gap-y-[50px] pb-3 md:pb-0">
            <motion.h3
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.6 }}
              viewport={{ once: true }}
              className="text-clamp15to30 text-white leading-1 
              ltr:!font-DINRegular ltr:md:!font-DINMedium [&>strong]:ltr:!font-DINMedium
              rtl:font-GESSTwoDWTCMedium mb-3 md:mb-[1.5rem]"
              dangerouslySetInnerHTML={{ __html: preApplicationTitle }}
            />
            {isEmpty(preApplicationList) || (
              <div className="flex flex-col gap-y-[30px] md:gap-y-[60px]">
                {map(preApplicationList, (item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.3 * (index + 1), delay: 0.7 }}
                    className="flex flex-row gap-x-5 xl:gap-x-[43px] items-center 
                    justify-between md:justify-normal">
                    <div className="flex flex-row gap-x-5 md:gap-x-8 items-center w-full">
                      <p
                        className="mb-0 min-w-[30px] md:w-[50px] min-h-[30px] md:h-[50px]
                        bg-[#CE435B] flex justify-center items-center rotate-45">
                        <span
                          className="font-LibreBaskervilleRegular text-clamp16to25 text-white
                        rotate-[-45deg]">
                          {item.content.number}
                        </span>
                      </p>
                      <h4
                        className="text-clamp13to25 md:w-[250px] xl:w-[370px] text-white
                        ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight leading-[1.3]">
                        {isEmpty(item.content.link) || (
                          <Link
                            href={item.content.link.url}
                            className="text-white hover:text-[#CE435B]">
                            {item.content.title}
                          </Link>
                        )}
                      </h4>
                    </div>
                    <div
                      className="flex flex-row md:gap-x-5 xl:gap-x-[87px] 
                    justify-between md:w-full">
                      <p
                        className="max-w-[570px] text-[#CCC] text-[16px] leading-1.375
                      ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight mb-0 hidden md:flex">
                        {item.content.text}
                      </p>
                      {isEmpty(item.content.link) || (
                        <Link
                          href={item.content.link.url}
                          className="svg-path:stroke-white svg-path:hover:stroke-[#CE435B]
                          w-12 flex ltr:justify-end rtl:justify-start px-2 rtl:-scale-x-100">
                          <Sprites name="arrownextnew" className="h-auto w-[10px] md:w-[15px]" />
                        </Link>
                      )}
                    </div>
                  </motion.div>
                ))}
              </div>
            )}
          </div>
          <div className="w-full h-[1px] bg-[#999]" />
          <div className="flex flex-col gap-y-[25px] md:gap-y-[50px] pt-[10px]  md:pt-0">
            <motion.h3
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.7 }}
              viewport={{ once: true }}
              className="text-clamp15to30 text-white leading-1 
              ltr:!font-DINRegular ltr:md:!font-DINMedium [&>strong]:ltr:!font-DINMedium
              rtl:font-GESSTwoDWTCMedium mb-3 md:mb-[1.5rem]"
              dangerouslySetInnerHTML={{ __html: postApplicationTitle }}
            />
            {isEmpty(postApplicationList) || (
              <div className="flex flex-col gap-y-[30px] md:gap-y-10">
                {map(postApplicationList, (item1, index1) => (
                  <motion.div
                    key={index1}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.3 * (index1 + 1), delay: 0.7 }}
                    className="flex flex-row gap-x-5 xl:gap-x-[43px] items-center 
                    justify-between md:justify-normal">
                    <div className="flex flex-row gap-x-5 md:gap-x-8 items-center w-full">
                      <p
                        className="mb-0 w-[30px] md:w-[50px] h-[30px] md:h-[50px] bg-white flex
                        justify-center items-center rounded-full">
                        <span
                          className="font-LibreBaskervilleRegular 
                        text-clamp16to25 text-[#4D4D4D]">
                          {item1.content.number}
                        </span>
                      </p>
                      <h4
                        className="text-clamp13to25 md:w-[250px] xl:w-[370px] text-white
                        ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight ltr:leading-1 
                        rtl:leading-[1.3]">
                        {item1.content.title}
                      </h4>
                    </div>
                    <div
                      className="flex flex-row md:gap-x-5 xl:gap-x-[87px] 
                    justify-between">
                      <p
                        className="w-[458px] text-[#CCC] text-[16px] leading-1.375
                      ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight mb-0 hidden md:flex">
                        {item1.content.text}
                      </p>
                      {isEmpty(item1.content.link) ? (
                        <span className='w-5'/>
                      ) : (
                        <Link
                          href={item1.content.link.url}
                          className="svg-path:stroke-white svg-path:hover:stroke-[#CE435B] 
                          w-12 flex ltr:justify-end rtl:justify-start px-2 rtl:-scale-x-100">
                          <Sprites name="arrownextnew" className="h-auto w-[10px] md:w-[15px]" />
                        </Link>
                      )}
                    </div>
                  </motion.div>
                ))}
              </div>
            )}
          </div>
        </div>
      </BoxedContainer>
    </section>
  );
}

